












import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../lib/abpbase";
import Ajax from "../lib/ajax";

@Component({
  components: {},
})
export default class CourtSelect extends AbpBase {
  @Prop({ type: String, default: "" }) value: string;

  targetKeys: Array<number> = new Array<number>();

  courtList: Array<any> = new Array<any>();

  titles = [this.L("AllCourts"), this.L("SelectedCourts")];

  renderItem(item) {
    return item.label;
  }
  handleChange(newTargetKeys, direction, moveKeys) {
    this.targetKeys = newTargetKeys;
    let strKeys = newTargetKeys.join(",");
    this.$emit("input", strKeys);
  }
  @Watch("value")
  onValueChange(newVal, oldVal) {
    let arrKeys = (newVal + "").split(",");
    let numArr = arrKeys
      .map((x) => {
        return parseInt(x, 10);
      })
      .filter((val) => !isNaN(val));
    this.targetKeys = numArr;
  }
  filterMethod(data, query) {
    return data.label.indexOf(query) > -1;
  }
  async created() {
    let rep = await Ajax.get("/api/services/app/Court/GetLabelKeys");
    if (rep.data.result) {
      this.courtList = rep.data.result;
    }
  }
}
